import { Modal, Button } from "react-bootstrap";

export default function DynamicModal({ show, title, body, onSave, onClose }) {
  return (
    <Modal
      show={show}
      onHide={onClose} // fires on Cancel, X, or backdrop
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>{body}</Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onSave}>
          Save changes
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
